import { init as initApm, AgentConfigOptions } from "@elastic/apm-rum";

//
// PARA RODAR LOCAL, DESCONMENTAR ABAIXO
//
/*
import * as dotenv from 'dotenv';
dotenv.config({ path: '.env' });
*/

//config no secret geral para todos os projetos
const apmConfig = JSON.parse(process.env.REACT_APP_APM_CONFIG || "{}");
//console.log(`[LOG] ~ apm.ts:13 ~ apmConfig =>`, apmConfig);

//config no configmap do projeto
const apmConfig2: Partial<AgentConfigOptions> = {
  serviceName: process.env.REACT_APP_APM_SERVICE_NAME || "",
  environment: process.env.REACT_APP_APM_ENV || "",
  breakdownMetrics: true,
  active: true,
  logLevel: "info",
  distributedTracing: true,
  pageLoadTraceId: "portal-ssr-front",
  propagateTracestate: true,
  //logLevel: "debug", // Logs detalhados
};
//console.log(`[LOG] ~ apm.ts:25 ~ apmConfig2 =>`, apmConfig2);

export const apmStart = () => {
  const apmEnabled = process.env.REACT_APP_APM_ENABLED || false;
  if (apmEnabled && apmConfig && apmConfig2) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const apm = initApm({ ...apmConfig, ...apmConfig2 } as any);
    console.log(">> APM inicializado!");
  } else {
    console.log(">> APM não inicializado!");
  }
};
